




































/* eslint-disable */
import getUrlParam from '@/common/utils/getUrlParam';
import { Component, Vue, Mixins,Prop } from "vue-property-decorator";
import PageInitialMixin from "@/mixins/PageInitialMixin";
import { Getter, Action } from "vuex-class";
import ActivityInfo from './ActivityInfo.vue'
import InstInfo from './InstInfo.vue'
@Component({
  components: {
    "activity-info": ActivityInfo,
    "inst-info": InstInfo,
  },
})
export default class BottomInfo extends Vue {

  @Getter("contactQrcode") contactQrcode!: string;
  @Getter("isAgain") isAgain!: string;
  @Getter("isInvalid") isInvalid: any;
  @Getter("title") title!: string;
  @Getter("instName") instName!: string;
  @Getter("startTime") startTime: any;
  @Getter("deadline") deadline!: any;
  @Getter("activityRule") activityRule!: string;
  @Getter("instAddress") instAddress!: string;
  @Getter("instPhone") instPhone!: string;
  @Getter("institutionIntros") institutionIntros!: Array<object>;
  @Action("changeShowFooter") changeShowFooter!: Function;
  isFromDistribute: boolean = true;
  message: object = {};
  hidden: boolean = false;
  activityStatus:string="noStart";
  showBtn: boolean = false;
  box: any = null;
  interval: any = {};
  created() {
  }
  mounted() {

    this.interval = setInterval(()=>{
      this.getActivityStatus();
    },1000)
    this.getScroll();
  }
  getScroll() {
    this.box = document.getElementById('cover-scroll');
    this.box.addEventListener('scroll',this.handleScroll)
  }

  beforeDestroy() {
    this.box.removeEventListener('scroll', this.handleScroll)
  }
  toInst() {
    let dom = (document.getElementById('inst-container'))||{offsetTop:0}
    let dom2 = (document.getElementById('main-title'))||{clientHeight:0}
    let scrollTop = dom.offsetTop + document.body.clientHeight+dom2.clientHeight;
    this.box.scrollTop = scrollTop;
    console.log(scrollTop);
  }
  toActivity() {
    let dom = (document.getElementById('intro-content'))||{offsetTop:0}
    let dom2 = (document.getElementById('main-title'))||{clientHeight:0}
    let scrollTop = dom.offsetTop + document.body.clientHeight+dom2.clientHeight;
    this.box.scrollTop = scrollTop;
    console.log(scrollTop);
  }
  handleScroll () {
    if(this.box.scrollTop>400) {
        this.showBtn = true;
    }else {
      this.showBtn = false;
    }
  }
  getActivityStatus(){
    const activityDeadline: number = this.deadline;
    const activityStartTime: number = this.startTime;
    const nowTimestamp: number = new Date().valueOf();
    if(activityStartTime > nowTimestamp){
      this.activityStatus = "noStart"
    }else{
      if(nowTimestamp<activityDeadline){
        this.activityStatus = "startIng";
      }else{
        this.activityStatus = "endIng";
      }
    }
  }
  goNext():void {
    if(this.isInvalid) {
      Vue.$toast.error("活动已失效");
    }else {
      if(this.activityStatus=='startIng') {
        if (window.TDAPP) {
          window.TDAPP.onEvent(this.isAgain?'首页点击再测一次':"首页点击开始测评", "小程序", {
          });
        }
        let url = `/pages/ask-info/index?openid=${this.$store.state.openId}`
        console.log('redirect', url);
        window.wx.miniProgram.navigateTo({
            url,
        });
      }else if(this.activityStatus=='noStart') {
        Vue.$toast.error("活动未开始");
      }else if(this.activityStatus=='endIng') {
        Vue.$toast.error("活动已结束");
      }
    }
  }
  gosee():void {
    if (window.TDAPP) {
      window.TDAPP.onEvent("首页点击查看报告", "小程序");
    }
    let url = `/pages/short-result/index?openid=${this.$store.state.openId}&activityId=${getUrlParam('broadcastId')}`
    console.log('redirect', url);
    window.wx.miniProgram.navigateTo({
        url,
    });
  }

  destroyed(){
    clearInterval(this.interval)
  }
}
